import { render, staticRenderFns } from "./DiscountCalc.vue?vue&type=template&id=5a4b7a11"
import script from "./DiscountCalc.vue?vue&type=script&lang=js"
export * from "./DiscountCalc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports